import gql from "graphql-tag";
import { Post } from "../types/post";
import { platform } from "~/platform/socket";
import { useTranslation } from "~/primitives/translator";

interface FetchPostsResult {
	posts: {
		modified: Post[];
	};
}

export async function fetchPosts(): Promise<Post[]> {

	// const modifiedAt = new Date().toISOString();

	const query = gql`
		query {
			posts {
				modified {
					id
					title
					summary
					content
					thumbnailUrl
					bannerUrl
					publishedAt
					topic {
						id
						name
					}
				}
			}
		}
	`;

	const result = await platform.query(query) as FetchPostsResult;
	const translator = useTranslation;

	return await Promise.all(
		result.posts.modified.map(async post => {

			const base = { ...post };

			const [title, summary, topic, content] = await Promise.all([
				useTranslation(post.title),
				useTranslation(post.summary),
				post.topic?.name ? translator(post.topic.name) : null,
				useTranslation(post.content)
			]);

			if (!!post.topic) {
				base.topic!.name = topic || "";
			}

			return Object.assign(base, { title, summary, content });
		})
	);
}

interface FetchPostResult {
	post: Post;
}

export async function fetchPost(id: string): Promise<Post> {

	const query = gql`
		query ($id: ID!) {
			post (id: $id) {
				id
				title
				content
				thumbnailUrl
				bannerUrl
				publishedAt
				topic {
					id
					name
				}
			}
		}
	`;

	const result = await platform.query(query, {
		id
	}) as FetchPostResult;

	return result.post;
}